import ky from 'ky';
import DEFAULT_OPTION from './default_option';

type SignInResponse = {
  accessToken: string | null;
  client: string | null;
  uid: string | null;
  expiry: string | null;
};

const postSignIn = async (
  email: string,
  password: string,
): Promise<SignInResponse> => {
  const options = {
    ...DEFAULT_OPTION,
    json: {
      email,
      password,
    },
  };
  const response = await ky.post('auth/sign_in', options);

  if (response.status !== 200) {
    return {
      accessToken: null,
      client: null,
      uid: null,
      expiry: null,
    };
  }

  return {
    accessToken: response.headers.get('access-token'),
    client: response.headers.get('client'),
    uid: response.headers.get('uid'),
    expiry: response.headers.get('expiry'),
  };
};

export default postSignIn;
